import { useEffect, useState } from 'react';
import { miniApp } from '@telegram-apps/sdk-react';
import { applyTheme, isTelegram, preferredDark, syncTelegramChrome } from './telegram';

/**
 * Тема: внутри Telegram — из клиента, снаружи — из системной настройки.
 * `data-theme` ставится на <html>, вся палитра переключается переменными.
 */
export function useTheme(): { dark: boolean } {
  const [dark, setDark] = useState(preferredDark);

  useEffect(() => {
    applyTheme(dark);
    syncTelegramChrome();
  }, [dark]);

  useEffect(() => {
    if (isTelegram()) {
      try {
        return miniApp.isDark.sub(setDark);
      } catch {
        return;
      }
    }
    if (typeof matchMedia !== 'function') return;
    const mq = matchMedia('(prefers-color-scheme: dark)');
    const onChange = (e: MediaQueryListEvent) => setDark(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return { dark };
}
